export const RouterYear = [
  {
    path: "/year/choice/:type", // 选择次卡
    name: "在线购票",
    component: (resolve) => require(/* webpackChunkName: "Year" */ ["@/views/year/Choice"], resolve),
  },
  {
    path: "/year/confirm", // 确认订单
    name: "确认订单",
    component: (resolve) => require(/* webpackChunkName: "Year" */ ["@/views/year/Confirm"], resolve),
  },
];
